export function checkTaxExemptNumberRequired(values) {
    if (values.taxExempt && !values.taxexemptnumber?.trim()) {
        return 'Tax exemption number is required.';
    }
    return null;
}
//# sourceMappingURL=rules.js.map